/**
 * @fileoverview GET handler for the "/analytics_dashboard/:app_group_id/credit_consumption_time_period_data" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { analyticsDashboardAppGroupIdCreditConsumptionTimePeriodData } from "./constants";
import type { AnalyticsDashboardAppGroupIdCreditConsumptionTimePeriodDataResult } from "./types";

export const getAnalyticsDashboardAppGroupIdCreditConsumptionTimePeriodData = reactQueryFetcherAdapter(
  analyticsDashboardAppGroupIdCreditConsumptionTimePeriodData,
  (
    signal: AbortSignal,
    appGroupId: string,
    startDate: number,
    endDate: number
  ): Promise<AnalyticsDashboardAppGroupIdCreditConsumptionTimePeriodDataResult> => {
    return fetch(
      `/analytics_dashboard/${appGroupId}/credit_consumption_time_period_data`,
      "GET",
      {
        start_date: startDate,
        end_date: endDate,
      },
      { signal }
    );
  }
);
